!(function() {
  var GridLayoutUIStore = require('share/components/controls/GridLayout/Izenda.GridLayoutUIStore');
  var CONSTANTS = require('logic/data/Izenda.ReportDesignerFormatsConstants');
  var action = require('mobx').action;
  const { create, round } = require('lodash/fp');

  function ReportFormatLayoutUIStore(width, rows, cols) {
    GridLayoutUIStore.call(
      this,
      CONSTANTS.ROW_HEIGHT, // Initial square cell dim
      CONSTANTS.ROW_HEIGHT, // Initial square cell dim
      width,
      rows,
      cols,
      false,
      false,
      true,
      false
    );
  }

  /**
   * Inherit GridLayoutUIStore
   * @type {[type]}
   */
  ReportFormatLayoutUIStore.prototype = create(GridLayoutUIStore.prototype, {
    constructor: ReportFormatLayoutUIStore
  });

  /**
   * Override default setViewWidth to re-calculate cellWidth by new width because
   * the report format auto-scale cell dimension by its parent size.
   */
  ReportFormatLayoutUIStore.prototype.setViewWidth = action(function setViewWidth(width) {
    var newCellWidth = round(width / this.cols);

    this.cellWidth = newCellWidth;

    GridLayoutUIStore.prototype.setViewWidth.call(this, width);

    this.recalculateLayoutPosition();
  });

  module.exports = ReportFormatLayoutUIStore;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Izenda.ReportFormatLayoutUIStore.js